import axios from 'axios';
import config from '@/config';
const {baseUrl} = config
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.delete['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.put['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.withCredentials = true;
axios.defaults.timeout = 3000;

const getLang = () => {
  const lang = localStorage.getItem('local') || "zh-CN";
  return `?lang=${lang}`
}
/**
 * webpackActive  在配置中webpack.DefinePlugin中添加
 */
export const socketIp = webpackActive && baseUrl.pro || baseUrl.dev;
const ipServer = `${socketIp}`;

export const login = params => { return axios.post(`${ipServer}/user/login${getLang()}`, params); };//账号登录
export const oblivion = params => { return axios.post(`${ipServer}/user/password/revise${getLang()}`, params); };//忘记密码
export const logOut = params => { return axios.get(`${ipServer}/user/login`, { params }); };//注销登录
export const logRevise = params => { return axios.put(`${ipServer}/user/revise${getLang()}`,params); };//修改密码
// export const verifyCode = () => { return axios.get(`${ipServer}/verify/code`);};//获取验证码
export const smsCode = (phone,params) => { return axios.get(`${ipServer}/sms/code/${phone}`,{ params });};//获取验证码
export const userRegister = params => { return axios.post(`${ipServer}/user/register${getLang()}`,params);};//普通用户注册
export const powerUserRegister = params => { return axios.post(`${ipServer}/powerUser/register${getLang()}`,params);};//高级用户注册

/* 开放平台 */
export const purposeGet = params => { return axios.get(`${ipServer}/purpose/get`, {params, timeout: 10000 }); };//获取应用场景
export const appGet = (params) => { return axios.get(`${ipServer}/app/get`,{params,timeout:10000}); };//获取应用
export const appCreate = params => { return axios.post(`${ipServer}/app/create${getLang()}`,params); };//创建应用
export const appDelete = params => { return axios.delete(`${ipServer}/app/delete${getLang()}`, { data: params }); };//删除应用
export const appEdit = params => { return axios.put(`${ipServer}/app/get${getLang()}`, params ); };//编辑应用
export const sdkDownload = `${ipServer}/api/sdk/download`;//下载sdk

export const deviceGet = (params) => { return axios.get(`${ipServer}/device/get`, { params, timeout: 10000 }); };//获取设备
export const deviceDelete = (params) => { return axios.delete(`${ipServer}/device/delete${getLang()}`, { data: params }); };//删除设备

export const sdkGet = params => { return axios.get(`${ipServer}/sdk/get`,{params,timeout:10000}); };//获取sdk

/* 管理员 */
export const userGet = (params) => { return axios.get(`${ipServer}/admin/user/get`,{params,timeout:10000}); };//获取账号信息
export const userUpdate	 = (params) => { return axios.put(`${ipServer}/admin/user/update${getLang()}`,params); };//修改账号信息
export const userDelete = (params) => { return axios.delete(`${ipServer}/admin/user/delete${getLang()}`, { data: params }); };//删除账号信息
export const sdkUserGet = (params) => { return axios.get(`${ipServer}/admin/sdk/get`,{params,timeout:10000}); };//获取SDK信息
export const sdkUserCreate = (params) => { return axios.post(`${ipServer}/admin/sdk/create${getLang()}`,params); };//创建SDK
export const sdkUserUpdate = (params) => { return axios.put(`${ipServer}/admin/sdk/update${getLang()}`,params); };//创建SDK
export const sdkUserDelete = (params) => { return axios.delete(`${ipServer}/admin/sdk/delete${getLang()}`, { data: params }); };//创建SDK

//SDK文件
export const sdkFileGet	 = (params) => { return axios.get(`${ipServer}/admin/sdkflie/get`,{params,timeout:10000}); };//获取SDK上传文件列表
export const sdkFileUpload = (params, config) => { return axios.post(`${ipServer}/admin/sdkflie/upload`, params, config); };//上传sdk文件
export const sdkFileDelete = (params) => { return axios.delete(`${ipServer}/admin/sdkflie/delete`, { data: params }); };//上传sdk文件


//应用管理
export const appPut = (params) => { return axios.put(`${ipServer}/app/get`,params); };//编辑应用
export const adminAppDelete = (params) => { return axios.delete(`${ipServer}/app/delete`,{ data: params }); };//删除应用

export const userAppKey = (params) => { return axios.get(`${ipServer}/admin/appKey/get`,{params,timeout:10000}); };//获取授权文件列表
export const userAppKeyCreate = (params) => { return axios.post(`${ipServer}/admin/appKey/create`,params); };//创建授权文件
export const userAppKeyDownload = `${ipServer}/admin/appKey/download`;//下载授权文件


export const userSdkGet	 = (params) => { return axios.get(`${ipServer}/admin/userSdk/get`,{params,timeout:10000}); };//获取账号与SDK关联
export const userSdkDelete	 = (params) => { return axios.delete(`${ipServer}/admin/userSdk/delete${getLang()}`,{ data: params }); };//删除账号与SDK关联
export const userSdkCreate	 = (params) => { return axios.post(`${ipServer}/admin/userSdk/create${getLang()}`,params); };//创建账号与SDK关联



// WEBPACK FOOTER //
// ./src/libs/api.js